import { render, staticRenderFns } from "./jgzsCov.vue?vue&type=template&id=34dad878&scoped=true"
import script from "./jgzsCov.vue?vue&type=script&lang=js"
export * from "./jgzsCov.vue?vue&type=script&lang=js"
import style0 from "./jgzsCov.vue?vue&type=style&index=0&id=34dad878&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34dad878",
  null
  
)

export default component.exports